import { tap, switchMap, filter, debounce } from "rxjs/operators";
import { formOperation } from "../../wrappers/formOperation";
import { Observable, timer } from "rxjs";
import { TActionsDefinitionsList } from "./TAction";
import { action, routeAction } from "./actionFunctions";
import { TStateLens } from "../../../../domain/codecs/state";
import { TCodecSetState, TGetCodecState } from "../applyActions";

export const actions: TActionsDefinitionsList = [
    routeAction("VIEW_CRM_LEGAL_CASE", (obs$, lens, setState, getState) => {
        obs$.pipe(
            tap((action) => setState(lens.case_compliance_raises_page.edited.id.set(action.params.caseId))),
        ).subscribe();
    }),

    action("CASE_COMPLIANCE_RAISES_VIEW", (obs$, lens, setState, getState) => {
        obs$.pipe(
            $loadRaises(lens, setState, getState),
        ).subscribe()
    }),

    action("CASE_COMPLIANCE_RAISES_UPDATE_FORM", (obs$, lens, setState, getState) => {
        obs$.pipe(
            tap((form) => setState(lens.case_compliance_raises_page.set(form))),
        ).subscribe()
    }),

    action("CASE_COMPLIANCE_RAISES_MARK_SAR", (obs$, lens, setState, getState) => {
        obs$.pipe(
            switchMap((form) => formOperation("CreateCaseSarRaised", form)),
            tap((response) => setState(lens.case_compliance_raises_page.children.create_sar.set(response))),

            filter((response) => response.status === "success"),
            $loadRaises(lens, setState, getState),
            debounce(() => timer(500)),
            tap(() => setState(lens.case_compliance_raises_page.children.create_sar.status.set("untouched"))),
        ).subscribe()
    }),

    action("CASE_COMPLIANCE_RAISES_MARK_INSURERS", (obs$, lens, setState, getState) => {
        obs$.pipe(
            switchMap((form) => formOperation("CreateCaseRaisedWithInsurers", form)),
            tap((response) => setState(lens.case_compliance_raises_page.children.create_insurers.set(response))),

            filter((response) => response.status === "success"),
            $loadRaises(lens, setState, getState),
            debounce(() => timer(500)),
            tap(() => setState(lens.case_compliance_raises_page.children.create_insurers.status.set("untouched"))),
        ).subscribe()
    }),

    action("CASE_COMPLIANCE_RAISES_UPDATE_NOTE", (obs$, lens, setState, getState) => {
        obs$.pipe(
            switchMap((form) => formOperation("UpdateCaseComplianceRaiseNote", form)),
            filter((response) => response.status === "success"),
            $loadRaises(lens, setState, getState),
        ).subscribe()
    }),

    action("CASE_COMPLIANCE_RAISES_REVOKE", (obs$, lens, setState, getState) => {
        obs$.pipe(
            switchMap((form) => formOperation("RevokeCaseComplianceRaise", form)),
            filter((response) => response.status === "success"),
            $loadRaises(lens, setState, getState),
        ).subscribe()
    }),
];

const $loadRaises = <T>(lens: TStateLens, setState: TCodecSetState, getState: TGetCodecState) =>
    (obs$: Observable<T>) =>
        obs$.pipe(
            switchMap(() => formOperation("GetCaseComplianceRaises", lens.case_compliance_raises_page.get()(getState()))),
            tap((raises) => setState(lens.case_compliance_raises_page.set(raises))),
        )
;
